import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import React, { cloneElement } from "react";
import {
  Button,
  Datagrid,
  Filter,
  FunctionField,
  ReferenceField,
  ResourceContextProvider,
  RowClickFunction,
  sanitizeListRestProps,
  SearchInput,
  ShowProps,
  TextField,
  TopToolbar,
  useListContext,
} from "react-admin";
import IconPlus from "@material-ui/icons/Add";
import { GridinRow, GridLabel } from "utils/style";
import CustomDateField from "components/CustomDateField";
import StatusField from "components/StatusField";
import { SchoolIdSelected } from "utils/tools";
import { GridAddIcon } from "@material-ui/data-grid";
import ScheduleType from "pages/students/components/ScheduleTypeColumn";
import { StyledList } from "../../components/ListWrapper";
import CustomPagination from "../../components/CustomPagination";

const ThisFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const ListActions = (props: any) => {
  const { className, exporter, filters, maxResults, history, ...rest } = props;
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}

      <Button
        onClick={() =>
          history.push(
            `/students/create?source=${JSON.stringify({
              parentId: Number(props.filterValues?.ParentId),
            })}&parentId=${Number(props.filterValues?.ParentId)}`
          )
        }
        label="Create Student"
      >
        <IconPlus />
      </Button>
    </TopToolbar>
  );
};

const Student = (props: ShowProps) => {
  const rowClick: RowClickFunction = (id, basePath, record) =>
    `/students/${id}/show?parentId=${props.id}`;

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Students</Typography>
      </Grid>
      <Grid item xs={12}>
        <ResourceContextProvider value="students">
          <StyledList
            {...props}
            exporter={false}
            filters={<ThisFilter />}
            filterDefaultValues={{
              ParentId: Number(props.id),
              IsMain: true,
              SchoolId: Number(SchoolIdSelected()),
            }}
            bulkActionButtons={false}
            title=" "
            actions={<ListActions history={props.history} />}
            pagination={<CustomPagination />}
          >
            <Datagrid rowClick={rowClick}>
              <FunctionField
                label="Student Info"
                render={() => (
                  <SanitizedGrid container spacing={2}>
                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Id :
                      </Typography>
                      <TextField source="id" emptyText="-" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Name :
                      </Typography>
                      <FunctionField
                        render={(record: any) =>
                          `${record.firstName} ${record.lastName}`
                        }
                        emptyText="-"
                      />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Gender :
                      </Typography>
                      <TextField source="gender" emptyText="-" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Birthday :
                      </Typography>
                      <CustomDateField source="dateOfBirth" emptyText="-" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        School :
                      </Typography>
                      <ReferenceField
                        source="schoolId"
                        reference="schools"
                        emptyText="-"
                        link={false}
                      >
                        <TextField source="name" emptyText="-" />
                      </ReferenceField>
                    </Grid>
                  </SanitizedGrid>
                )}
              />
              <FunctionField
                label="Schedule"
                render={(record: any) => (
                  <ScheduleType
                    regularStatus={record.regularStatus}
                    ccaStatus={record.ccaStatus}
                  />
                )}
              />
              <StatusField source="status" />
              <CustomDateField
                source="createdAt"
                label="Created On"
                emptyText="-"
                isDateTime
              />
              <FunctionField
                label="Actions"
                render={(props: any) => (
                  <>
                    <AddScheduleButton {...props} />
                  </>
                )}
              />
            </Datagrid>
          </StyledList>
        </ResourceContextProvider>
      </Grid>
    </SanitizedGrid>
  );
};

const AddScheduleButton = (record: IStudent) => (
  <>
    {record.regularStatus === "inactive" && (
      <Button
        href={`/#/studentSchedules/create/?source=${JSON.stringify({
          studentId: record.id,
          parentId: record.parent.id,
          schoolId: record.schoolId,
        })}&studentId=${record.id}&parentId=${record.parent.id}`}
        label="Add Regular Schedule"
      >
        <GridAddIcon />
      </Button>
    )}
    {record.ccaStatus === "inactive" && (
      <Button
        href={`/#/ccaStudentSchedules/create/?source=${JSON.stringify({
          studentId: record.id,
          parentId: record.parent.id,
          schoolId: record.schoolId,
        })}&studentId=${record.id}&parentId=${record.parent.id}`}
        label="Add CCA Schedule"
      >
        <GridAddIcon />
      </Button>
    )}
  </>
);

export default Student;
